// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"fbc5fc35","178":"dd4144b8","586":"590c2a99","852":"a3d7e94f"}[chunkId] + ".chunk.js";
};